/* eslint-disable no-prototype-builtins */
import makeFetchCall, {CommonFetchMethods} from '../utils/makeFetchCall';

const endpoint = '/api/auth'; // TODO: check on having these come from env-vars (or be overwritten by them)

const loginUser = async ({ email, password }) => {
    const fetchResult = await makeFetchCall(
        `${endpoint}/login`,
        { email, password },
        CommonFetchMethods.POST,
        null,
        true
    );
    const returnData = {
        isLoggedIn: false,
        accountInfo: null
    };
    returnData.isLoggedIn = fetchResult.result;
    if (fetchResult.hasOwnProperty('accountInfo')) {
        returnData.accountInfo = fetchResult.accountInfo;
    }
    return returnData;
};

const registerAccount = async ({ firstName, lastName, email, password, passwordConfirm }) => {
    const fetchResult = await makeFetchCall(`${endpoint}/register`, { firstName, lastName, email, password, passwordConfirm });
    const returnData = {
        isLoggedIn: false,
        accountInfo: null
    };
    returnData.isLoggedIn = fetchResult.result;
    if (fetchResult.hasOwnProperty('accountInfo')) {
        returnData.accountInfo = fetchResult.accountInfo;
    }
    return returnData;
};

const resetPasswordRequest = async ({ email }) => {
    const fetchResult = await makeFetchCall(`${endpoint}/resetPassword`, { email });
    return fetchResult.result;
};

const logoutUser = () => {
    localStorage.clear();
    // noinspection JSIgnoredPromiseFromCall
    makeFetchCall('/logout');
};

const AuthService = {
    loginUser,
    logoutUser,
    registerAccount,
    resetPasswordRequest
};

export default AuthService;
